import { momentify } from '../../shared/js/dateUtils';

$(function () {
  const isMobile = /iPhone|iPod|Android/i.test(navigator.userAgent);
  const isMobileScreen = window.innerWidth <= 767;
  const isCarSearchPage = $('body').hasClass('car-search-page');

  // Vehicle type
  document.getElementById('dd-car-list')?.addEventListener('click', function (event){
    var dropdown = document.querySelector('.dd-list-car');
    if (!dropdown.classList.contains('hidden') && dropdown.classList.contains('block')) {
      dropdown.classList.add('hidden');
      dropdown.classList.remove('block');
    } else {
      dropdown.classList.remove('hidden');
      dropdown.classList.add('block');
    }
    event.stopPropagation();
  });

  document.addEventListener('click', function (event) {
    var dropdown = document.querySelector('.dd-list-car');
    if (!dropdown?.contains(event.target) && !document.getElementById('dd-car-list')?.contains(event.target)) {
      dropdown?.classList.add('hidden');
      dropdown?.classList.remove('block');
    }
  });

  var targetSpan = document.querySelector('.list-checkbox li#dropdown-car-list label span.car-name');
  var targetImage = document.querySelector('.list-checkbox li#dropdown-car-list label img');

  document.querySelectorAll('.dd-list-car ul li label input').forEach(function (checkbox) {
    if (checkbox.checked) {
      var spanText = checkbox.nextElementSibling.querySelector('span.text-grey-3').innerText;
      // Replace the image and text with the selected car
      var imageSrc = checkbox.nextElementSibling.querySelector('img').src;
      var imageAlt = checkbox.nextElementSibling.querySelector('img').alt;
      targetImage.src = imageSrc;
      targetImage.alt = imageAlt;
      targetSpan.innerHTML = ' ' + spanText;

      // Add the <i></i> icon
      var icon = document.createElement('i');
      icon.classList.add('fa-solid', 'fa-chevron-down', 'ml-[6.5px]', 'text-grey-3', 'text-xs');
      targetSpan.appendChild(icon);

      document.getElementById('dd-car-list').classList.add('active-type');
    }

    checkbox.addEventListener('click', function () {
      var spanText = this.nextElementSibling.querySelector('span.text-grey-3').innerText;
      var dropdownarea = document.querySelector('.dd-list-car');

      // Uncheck all other checkboxes and remove their images and text
      document.querySelectorAll('.dd-list-car ul li label input').forEach(function (otherCheckbox) {
        if (otherCheckbox !== checkbox) {
          otherCheckbox.checked = false;
        }
      });

      // If targetImage doesn't exist, create it
      if (!targetImage) {
        targetImage = document.createElement('img');
        targetImage.classList.add('selected-car-image');
        document.querySelector('.list-checkbox li#dropdown-car-list label').prepend(targetImage);
      }

      if (this.checked) {
        // Replace the image and text with the selected car
        var imageSrc = this.nextElementSibling.querySelector('img').src;
        var imageAlt = this.nextElementSibling.querySelector('img').alt;
        targetImage.src = imageSrc;
        targetImage.alt = imageAlt;
        targetSpan.innerHTML = ' ' + spanText;

        // Add the <i></i> icon
        var icon = document.createElement('i');
        icon.classList.add('fa-solid', 'fa-chevron-down', 'ml-[6.5px]', 'text-grey-3', 'text-xs');
        targetSpan.appendChild(icon);

        document.getElementById('dd-car-list').classList.add('active-type');
      } else {
        // Clear the image and text if unchecked
        targetImage.src = './assets/images/other-car.svg';
        targetImage.alt = 'other';
        targetSpan.innerHTML = 'other';

        // Add the <i></i> icon
        var icon = document.createElement('i');
        icon.classList.add('fa-solid', 'fa-chevron-down', 'ml-[6.5px]', 'text-grey-3', 'text-xs');
        targetSpan.appendChild(icon);

        document.getElementById('dd-car-list').classList.remove('active-type');
      }

      // Close the dropdown after selecting an input
      dropdownarea.classList.add('hidden');
      dropdownarea.classList.remove('block');
    });
  });

  $('#vehicallist-hero .select-radio').click(function () {
    $('#dd-car-list.active-type').removeClass('active-type');
  });

  //
  // Place input (Desktop)
  //
  $('#tags-country').autocomplete({
    serviceUrl: window.citySearchUrl,
    minChars: 2,
    onSearchStart: function() {
      $('.autocomplete-suggestions').hide();
      showAutocompleteLoading();
    },
    onSearchComplete: function () {
      $('.autocomplete-suggestions').show();
      if (!$('.autocomplete-suggestions .autocomplete-suggestion').length) {
        $('.autocomplete-suggestions').hide();
      }

      $('.autocomplete-loading').hide()
    }
  }).on('input', function () {
    $('#close_icons').toggle($(this).val().trim() !== '')
  });
  $('#close_icons').toggle($('#tags-country').val().trim() !== '')
    .on('click', function() {
      $('#tags-country').val('').end().hide();
      $('#close_icons').hide();
    });
  $(window).scroll(function () {
    $('.autocomplete-suggestions').css('top', ($('#tags-country').offset().top + $('#tags-country').outerHeight()) + 'px');
  });
  function showAutocompleteLoading() {
    $('.autocomplete-loading').show()
      .css('top', ($('#tags-country').outerHeight() * 2) + 'px');
  }
  $(document).on('click', '.close-icon-search', function() {
    $('.autocomplete-suggestions').hide();
  });

  //
  // Place input (mobile)
  //
  $('.rental-popup-search #search_country_select_rental li.js_init2').on('click', function () {
    $('#search-result-popup-rental').show();
    $('#close_icons_country').show();
    $('#searchInputRental').focus();
  });
  $('.rental-popup-search #search-area-rental li').on('click', function () {
    $('.rental-popup-search #search-area-rental li').removeClass('active');
    const clickedText = $(this).text();
    const dataValue = $(this).attr('data-value');
    $('.rental-popup-search #search_country_select_rental li.js_init2')
      .text(clickedText)
      .addClass('active')
      .attr('data-value', dataValue);
    $(this).addClass('active');
    $('.rental-popup-search #search-result-popup-rental').hide();
    $('.rental-popup-search button#close_icons_country').show();
  });
  $('.rental-popup-search button#close_icons_country').on('click', function () {
    $('.rental-popup-search #search-area-rental li')
      .removeClass('active')
      .show();
    $('.rental-popup-search #search_country_select_rental li.js_init2')
      .removeClass('active')
      .text(window.i18next.t('first_page.subscription.anywhere'))
      .removeAttr('data-value');
    $(this).hide();
    $('.rental-popup-search #searchInputRental').val('');
  });
  $('.rental-popup-search p#close_search_popup_rental').on('click', function () {
    $('.rental-popup-search #search-result-popup-rental').hide();
    $(".rental-popup-search #close_icons_country").hide();
  });
  let debounce = null;
  let request = null;
  $('#searchInputRental').keyup(function () {
    let searchQuery = $('#searchInputRental').val().toLowerCase();

    $('#noResultsMessageRental').hide();
    $('#searchSpinner').show();
    $('#search-area-rental').children().remove();

    clearTimeout(debounce);
    debounce = setTimeout(function() {
      if (request) {
        request.abort();
      }

      request = $.ajax({
        url: window.citySearchUrl,
        dataType: 'json',
        data: {
          query: searchQuery
        },
        success: function (data) {
          $('#noResultsMessageRental').hide();
          $('#searchSpinner').hide();
          $('#search-area-rental').children().remove();

          data.suggestions.forEach(suggestion => {
            $('#search-area-rental')
              .append('<li class="country-name" data-value="' + suggestion.value + '">' + suggestion.name + '</li>');
          });

          $('#search-area-rental li').click(function () {
            $('#search-area-rental li').removeClass('active');
            const clickedText = $(this).text();
            const dataValue = $(this).attr('data-value');
            $('#search_country_select_rental li.js_init2').text(clickedText)
              .addClass('active')
              .attr('data-value', dataValue);
            $(this).addClass('active');
            $('#search-result-popup-rental').hide();
            $('button#close_icons_country').show();
            $('#tags-country').val(dataValue);
          });

          if (!data.suggestions.length) {
            $('#noResultsMessageRental').show();
          }
        }
      });
    }, 300);
  });

  //
  // Datepicker
  //
  $("#rental_start_date").click(function () {
    $(this).addClass('active-stoke');
  });

  let showMonths = isMobileScreen ? 36 : 2;

  // Calendar config
  const calendarConfig = {
    mode: 'range',
    dateFormat: window.phpDateFormat,
    defaultDate: [
      window.pickupAt ? momentify(window.pickupAt).format(window.jsDateFormat) : undefined,
      window.deliveryAt ? momentify(window.deliveryAt).format(window.jsDateFormat) : undefined,
    ],
    minDate: "today",
    showMonths,
    position: 'below',
    disableMobile: true,
    closeOnSelect: !isMobileScreen,
    locale: {
      ...window.appLocale,
      firstDayOfWeek: window.weekStartDay,
      weekdays: {
        shorthand: [
          window.i18next.t('calendar.week_day.sunday.short')[0],
          window.i18next.t('calendar.week_day.monday.short')[0],
          window.i18next.t('calendar.week_day.tuesday.short')[0],
          window.i18next.t('calendar.week_day.wednesday.short')[0],
          window.i18next.t('calendar.week_day.thursday.short')[0],
          window.i18next.t('calendar.week_day.friday.short')[0],
          window.i18next.t('calendar.week_day.saturday.short')[0],
        ],
        longhand: [
          window.i18next.t('calendar.week_day.sunday.long'),
          window.i18next.t('calendar.week_day.monday.long'),
          window.i18next.t('calendar.week_day.tuesday.long'),
          window.i18next.t('calendar.week_day.wednesday.long'),
          window.i18next.t('calendar.week_day.thursday.long'),
          window.i18next.t('calendar.week_day.friday.long'),
          window.i18next.t('calendar.week_day.saturday.long'),
        ]
      },
      months: {
        shorthand: [
          window.i18next.t('calendar.month.january.short'),
          window.i18next.t('calendar.month.february.short'),
          window.i18next.t('calendar.month.march.short'),
          window.i18next.t('calendar.month.april.short'),
          window.i18next.t('calendar.month.may.short'),
          window.i18next.t('calendar.month.june.short'),
          window.i18next.t('calendar.month.july.short'),
          window.i18next.t('calendar.month.august.short'),
          window.i18next.t('calendar.month.september.short'),
          window.i18next.t('calendar.month.october.short'),
          window.i18next.t('calendar.month.november.short'),
          window.i18next.t('calendar.month.december.short'),
        ],
        longhand: [
          window.i18next.t('calendar.month.january.long'),
          window.i18next.t('calendar.month.february.long'),
          window.i18next.t('calendar.month.march.long'),
          window.i18next.t('calendar.month.april.long'),
          window.i18next.t('calendar.month.may.long'),
          window.i18next.t('calendar.month.june.long'),
          window.i18next.t('calendar.month.july.long'),
          window.i18next.t('calendar.month.august.long'),
          window.i18next.t('calendar.month.september.long'),
          window.i18next.t('calendar.month.october.long'),
          window.i18next.t('calendar.month.november.long'),
          window.i18next.t('calendar.month.december.long'),
        ]
      },
      rangeSeparator: ` ${window.i18next.t('first_page.subscription.to')} `
    },
    // formatDate(date, format, locale) {
    //   return momentify(date).format(window.jsDateFormat);
    // },
    // parseDate(dateStr, format) {
    //   return momentify(dateStr).toDate();
    // },
    onChange: function(selectedDates, dateStr, instance) {
      const rentalStartDateInput = $("#rental_start_date");
      const rentalEndDateInput = $("#rental_end_date");
      instance.input.classList.remove('car-rental-end', 'rental_end_date', 'start-on-monday');
      rentalStartDateInput.removeClass('active-stoke');
      rentalEndDateInput.removeClass('active-stoke');

      if (selectedDates.length > 0) {
        instance.input.classList.add('car-rental-end', 'rental_end_date');
        if (selectedDates.length < 2) {
          rentalEndDateInput.addClass('active-stoke');
        }

        if (instance.input.id === 'rental_start_date') {
          const [formattedStartDate, formattedEndDate] = dateStr.split(" " + window.i18next.t('first_page.subscription.to') + " ");
          rentalStartDateInput.val(formattedStartDate || '');
          rentalEndDateInput.val(formattedEndDate || '');
          updateSelectDateText(selectedDates);
          $('#pickup_at').val(
            momentify(selectedDates[0]).format('YYYY-MM-DD'),
          );
          $('#delivery_at').val(
            momentify(selectedDates[1]).format('YYYY-MM-DD'),
          );
        }
      }

      if (isMobileScreen && window.visibleMonthsRental >= 8) {
        $('.rental_datepicker_start .dayContainer').slice(4, window.visibleMonthsRental).css('display', 'grid');
        $('.rental_datepicker_start .all-months-name .months-load-more:nth-child(-n+' + (window.visibleMonthsRental - 4) + ')').css('display', 'block');
      }
    }
  };
  function updateSelectDateText(selectedDates) {
    let selectDateText = $(".flatpickr-calendar > .select-date > p");
    let whenDateText = $(".flatpickr-calendar > .starting-date > h3");

    let UIStartDateText = momentify(selectedDates[0] || '').locale(window.appLocale).format('ddd D MMM YYYY');
    let UIEndDateText = momentify(selectedDates[1] || '').locale(window.appLocale).format('ddd D MMM YYYY');
    if (selectedDates[1] === undefined) {
      UIEndDateText = '';
    }
    if (selectedDates[0] === undefined) {
      UIStartDateText = '';
    }
    if (selectedDates.length === 2) {
      const dayDiff = momentify(selectedDates[1]).diff(selectedDates[0], 'days');
      whenDateText.html(`${dayDiff} ${window.i18next.t(`layout.days_rental.${dayDiff > 0 ? 'plural' : 'singular'}`)}`);
    } else {
      whenDateText.html(window.i18next.t('first_page.subscription.starting_when'));
    }
    if (selectedDates.length !== 0) {
      selectDateText.html(`${UIStartDateText} - ${UIEndDateText}`);
    }
  }
  // Start date input
  const startingDateCalendar = flatpickr($('#rental_start_date'), {
    ...calendarConfig,
    onReady: function(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.add('rental_datepicker_start', 'rental_start_end');

      if (selectedDates.length > 0) {
        const [formattedStartDate, formattedEndDate] = dateStr.split(" " + window.i18next.t('first_page.subscription.to') + " ");
        $("#rental_start_date").val(formattedStartDate || '');
        $("#rental_end_date").val(formattedEndDate || '');
      }
    },
    onOpen: function(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.add('rental_start_left_space');

      if (isMobileScreen) {
        document.activeElement.blur();
        updateSelectDateText(selectedDates);
        repositionMonthNames();
      }

      if (!isMobileScreen) {
        $('.numInput').attr('readonly', true);
      }
    }
  });

  // End date input
  const endingDateCalendar = flatpickr($('#rental_end_date'), {
    ...calendarConfig,
    defaultDate: window.deliveryAt ? momentify(window.deliveryAt).format(window.jsDateFormat) : undefined,
    onReady: function(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.add('rental_datepicker_end', 'rental_start_end');
    },
    onOpen: function(selectedDates, dateStr, instance) {
      $('#rental_start_date').click();
      setTimeout(function () {
        $('#rental_start_date').click();
      }, 100);
      instance.calendarContainer.classList.add('rental_end_left_space');
      $('.rental_datepicker_end').removeClass('open');

      if (isMobileScreen) {
        document.activeElement.blur();
        repositionMonthNames();
      }

      if (!isMobileScreen) {
        $('.numInput').attr('readonly', true);
      }
    }
  });
  // For mobile, expand the calendar to show more months from today to selected date
  if (window.pickupAt && isMobileScreen) {
    const diffMonths = Math.round(momentify(window.pickupAt).diff(new Date(), 'months', true));
    if (diffMonths > 0 && diffMonths < 2) {
      startingDateCalendar.changeMonth(-1);
    } else {
      for (let i = 0; i < diffMonths; i++) {
        startingDateCalendar.changeMonth(-1);
      }
    }
  }

  if (!isMobile && isCarSearchPage) {
    function calculateElementDistanceFromWindow(selector) {
      const scrollTop = $(window).scrollTop();
      const elementOffset = $(selector).offset().top;
      return (elementOffset - scrollTop) + $(selector).innerHeight();
    }

    // Move calendar on scroll, following the input
    function moveCalendar(selector, animate) {
      if (!$(selector).length) {
        return;
      }

      let distance = calculateElementDistanceFromWindow(selector);

      if (animate) {
        $('.flatpickr-calendar.open').animate({ top: distance + 'px' }, 310, function () {
          distance = calculateElementDistanceFromWindow(selector);
          $(this).css('top', distance + 'px')
        })
      } else {
        $('.flatpickr-calendar.open').css('top', distance + 'px')
      }
    }

    // Expand search bar when focused
    $(document).ready(function() {
      moveCalendar('#rental_start_date');

      const elementsToShow = $('.rental-search-hidden, .car-rental-search, #page-skeleton-desktop');
      $('#searchDesktop').click(function () {
        elementsToShow.addClass('show');

        moveCalendar('#rental_start_date', true)
      })

      $(document).click(function(event) {
        const exceptions = $('#tags-country-search, #rental_start_date_search, #rental_end_date_search, #searchDesktop, #search-rental-btn').toArray()

        const isClickInsideExceptions = exceptions.some(element => element && (element.contains(event.target) || element === event.target));
        if (!isClickInsideExceptions) {
          elementsToShow.removeClass('show');
        }
      });

      $(window).scroll(function() {
        moveCalendar();
      });
    });
  }

  // Reposition month names for the mobile calendar
  const alreadyProcessedMonths = [];
  async function repositionMonthNames() {
    if (!isMobileScreen) {
      return;
    }

    await new Promise(resolve => setTimeout(resolve, 200));

    // select all div with class month-name-* and style attribute
    const displayingMonthNames = $('.all-months-name div[style]');
    const daysContainer = $('.dayContainer');
    displayingMonthNames.each(function (index) {
      if (index === 0) {
        return; // First one is always at the top as per css
      }

      const processingMonth = $(this).text() + $(this).find('.numInput').val();
      if (alreadyProcessedMonths.includes(processingMonth)) {
        return;
      }
      alreadyProcessedMonths.push(processingMonth);

      $(this).css('top', '0px'); // Reset the top to 0!

      const previousMonthDaysContainer = daysContainer.eq(index - 1);
      const nextMonthDaysContainer = daysContainer.eq(index);

      const previousMonthBottom = previousMonthDaysContainer.offset().top + previousMonthDaysContainer.outerHeight();
      const nextMonthTop = nextMonthDaysContainer.offset().top;

      let spaceBetweenContainers = nextMonthTop - previousMonthBottom;
      if (index === 1) {
        spaceBetweenContainers += previousMonthDaysContainer.outerHeight() + 40;
      }
      else if (index > 1) {
        const previous = displayingMonthNames.eq(index - 1).css('top');
        spaceBetweenContainers += (parseInt(previous) + previousMonthDaysContainer.outerHeight());
      }
      $(this).css('top', spaceBetweenContainers +  'px');
    });
  }

  //
  // Datepicker (Mobile)
  //
  if (isMobileScreen) {
    const calendarMobileHeader = $('<div class="flatpickr-header"></div>')
      .append("<p>" + window.i18next.t('first_page.subscription.select_date') + "</p>")
      .append(
        $('<button class="flatpickr-close" type="button"></button')
          .append('<i class="fa-solid fa-xmark"></i>')
          .click(function () {
            document.querySelector('#rental_start_date')._flatpickr.close()
          })
      )
    const whenTitle = $('<div class="starting-date"></div>')
      .append("<h3>" + window.i18next.t('first_page.subscription.starting_when') + "</h3>");
    const selectDateLabel = $('<div class="select-date"></div>')
      .append("<p>" + window.i18next.t('first_page.subscription.select_date') + "</p>");
    const calendarFooter = $('<div class="flatpickr-footer"></div>')
      .append('<button class="flatpickr-close" type="button">' + window.i18next.t('first_page.subscription.back') + '</button>')
      .append(
        $('<button class="button-orange">' + window.i18next.t('first_page.subscription.search') + '</button>')
          .append('<i class="fas fa-search"></i>')
          .click(function () {
            document.querySelector('#rental_start_date')._flatpickr.close()
          })
      );

    $('.rental_datepicker_start')
      .append(calendarMobileHeader)
      .append(whenTitle)
      .append(selectDateLabel)
      .append(calendarFooter);

    const calendarDatesContainer = $('.rental_datepicker_start .flatpickr-innerContainer .flatpickr-rContainer');
    if (calendarDatesContainer) {
      const monthsContainer = $('<div class="all-months-name"></div>');
      for (let i = 1; i <= calendarConfig.showMonths; i++) {
        const style = i <= 4 ? 'style="display: block;"' : '';
        const monthContainer = $('<div class="month-name-' + i + ' months-load-more" ' + style + '></div>').append(
          $('.rental_datepicker_start .flatpickr-months div:nth-child(' + (i + 1) + ')').children().first()
        );
        monthsContainer.append(monthContainer);
      }
      calendarDatesContainer.append(monthsContainer);

      window.visibleMonthsRental = 4;

      const loadMoreDatesButton = $('<button id="load_dates_mobile">' + window.i18next.t('first_page.subscription.load_more_dates') + '</button>').click(function () {
        $('.rental_datepicker_start .dayContainer').slice(window.visibleMonthsRental, window.visibleMonthsRental + 4).css('display', 'grid');
        $('.rental_datepicker_start .all-months-name .months-load-more:nth-child(-n+' + (window.visibleMonthsRental + 4) + ')').css('display', 'block');
        window.visibleMonthsRental += 4;
        if (window.visibleMonthsRental >= $('.rental_datepicker_start .dayContainer').length) {
          $('.rental_datepicker_start #load_dates_mobile').css('display', 'none');
        }

        repositionMonthNames();
      })
      calendarDatesContainer.append(
        $('<div class="dates_load"></div>').append(loadMoreDatesButton)
      )
    }
  }

  //
  // Age picker (Mobile)
  // For desktop we don't need it, because is a select input
  //
  $('#mobileSelectAge li').on('click', function () {
    $('select[name="age"]').val(
      parseInt($(this).attr('data-value'))
    )

    $('.age-drop').text($(this).text())
  });
  const urlParams = new URLSearchParams(window.location.search);
  const age = urlParams.get('age') || window.defaultSelectedAge;
  $('.age-drop').text(
    $(`#mobileSelectAge li[data-value="${age}"]`).text()
  )

  //
  // Show search form for mobile
  //
  function toggleSearchForm() {
    $('#searchBar').toggleClass('active');
    $('#searchDesktop').toggleClass('active');
    $('body').toggleClass('overflow-hidden');
  }

  $('#searchMobile, #close-mobile-search-area').click(function () {
    toggleSearchForm();
  });

  $("#search_booking_form").on("submit", function(event) {
    const startDate = $("#rental_start_date");
    const endDate = $("#rental_end_date");
    if (startDate.val() === '') {
      startDate.prop('readonly');
      startDate.focus();
      event.preventDefault();
    }
    if (endDate.val() === '') {
      endDate.removeAttr('readonly');
      endDate.focus();
      event.preventDefault();
    }
  });
});
